import { Fancybox } from "@fancyapps/ui";
console.log("box");

document.addEventListener('DOMContentLoaded', function () {
    Fancybox.bind("[data-fancybox='gallery']", {
        Carousel: {
            transition: 'slide',
        },
        Thumbs: {
            type: 'modern',
        },
        Image: {
            fitToView: true, // Ensures the image fits within the viewport
            zoom: true, // Allows users to zoom in and out
            wheel: 'zoom', // Allow zooming with the mouse wheel
            maxWidth: '90%', // Ensures images don’t exceed viewport width
            maxHeight: '90%',
        },
    });
});

console.log('after bind?');